import { observer } from 'mobx-react';
import React from 'react';
import { PageHeader } from '../../components/page-header';
import { Option } from '../../components/select';
import { InitialData } from '../../core/initial-data';
import { injectTSDI } from '../../core/tsdi';
import { CreateFacilityForm } from './form';

export const FacilityCreate = observer(() => {
    const { studioCategories, availableCountries } = injectTSDI(InitialData);

    return (
        <>
            <PageHeader title="Create new facility" />
            <CreateFacilityForm
                studioCategories={studioCategories.$.map(
                    (entry) =>
                        ({
                            label: entry.label,
                            value: entry.value
                        }) as Option<string>
                )}
                countryOptions={availableCountries.$}
            />
        </>
    );
});
